import ILoader from "./Iloader";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import FontPreloader from "./FontPreloader";
import LoadingScreen from "./LoadingScreen";
import events from "../events/EventsObservable";
import IDOM from "../ui/IDOM";

export const LOADER_EVENTS = {
    "LOADER_HIDED": "LOADER_HIDED"
};

@injectable()
export default abstract class BaseLoader implements ILoader {

    protected fontPreloader: FontPreloader;
    protected loadingScreen: LoadingScreen;
    protected dom: IDOM;

    protected constructor(
        @inject(SERVICE_IDENTIFIER.LoadingScreen) loadingScreen: LoadingScreen,
        @inject(SERVICE_IDENTIFIER.FontPreloader) fontPreloader: FontPreloader,
        @inject(SERVICE_IDENTIFIER.DOM) dom: IDOM
    ) {
        this.loadingScreen = loadingScreen;
        this.fontPreloader = fontPreloader;
        this.dom = dom;
    }

    async init() {
        this.fontPreloader.initFontPreloader(this.dom.getFontPreloaderWrapper());
        this.loadingScreen.create();

        // load sprite.svg and add it to body
        $.get("./framework/assets/img/inline/ui/sprite.svg", function(data) {
            var div = document.createElement("div");
            div.innerHTML = new XMLSerializer().serializeToString(data.documentElement);
            document.body.insertBefore(div, document.body.childNodes[0]);
        });
    }

    async preload() {
        this.fontPreloader.preload();
    }

    async hide() {
        await this.loadingScreen.hide();
        events.dispatch(LOADER_EVENTS.LOADER_HIDED);
    }

    async onCreate() {};
    abstract load();
    abstract loadComplete(data);
}
